export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ancient%20historical%20scrolls%20and%20manuscripts%20in%20warm%20library%20setting%2C%20dramatic%20chiaroscuro%20lighting%2C%20aged%20parchment%20texture%2C%20classical%20architecture%20arches%20in%20background%2C%20scholarly%20atmosphere%2C%20rich%20amber%20and%20gold%20tones%2C%20no%20text%20overlay%2C%20museum%20quality%20fine%20art%20photography&width=1920&height=1080&seq=hero-bg-91-events&orientation=landscape"
        alt="91大事件 - 历史上的重大时刻全解析"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-background-50 text-center mb-4 md:mb-6 leading-tight max-w-3xl">
          历史上的重大时刻全解析
        </h1>
        <p className="text-sm md:text-base text-background-50/85 text-center max-w-2xl mb-6 md:mb-8 leading-relaxed">
          从政治变革到经济转折，从科技突破到文化运动，深度盘点那些改变世界进程的重大历史节点。91大事件为你还原最真实的历史脉络。
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href="#categories"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors no-underline cursor-pointer"
          >
            探索事件分类
          </a>
          <a
            href="#featured"
            className="px-6 py-2.5 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md text-sm font-medium whitespace-nowrap hover:bg-background-50/25 transition-colors no-underline cursor-pointer"
          >
            查看精选文章
          </a>
        </div>
      </div>
    </section>
  );
}